<template>
    <BaseModal :width="400" title="删除确认" v-model="show">
        <a-alert :show-icon="true" type="warning">
            <div slot="message">
                您正在删除 <b>{{album.name}}</b>，删除将清空所有内容，请确认已做好数据备份，此操作无法恢复！
            </div>
        </a-alert>
        <div style="position: relative;margin: 20px 0;">
            <a-input placeholder="请输入6位操作确认验证码" v-model="code">
                <a-icon slot="prefix" style="color:rgba(0,0,0,.25)" type="lock"/>
                <VueCodeButton @click="sendCode" class="code-button" slot="suffix"/>
            </a-input>
        </div>
        <div style="width: 140px; margin: 0 auto;">
            <SaveButton :action="submit" :disabled="!(code && album.id)" title="确认删除" type="danger"/>
        </div>
    </BaseModal>
</template>

<script>
    import api from "../../../../utils/api";
    import cache from "../../../../utils/cache";
    import BaseModal from "../../../../comps/BaseModal";
    import SaveButton from "../../../../comps/SaveButton";
    import {VueCodeButton} from "@basic/vue-code";

    export default {
        name: "DeleteConfirm",
        components: {SaveButton, BaseModal, VueCodeButton},
        data() {
            return {
                show: false,
                code: "",
                album: {},
            }
        },
        methods: {
            open(member) {
                this.code = "";
                this.album = member.album;
                this.show = true;
            },
            submit() {
                return cache.v1.album
                    .delete(this.album.id, this.code)
                    .then(() => {
                        return api.v1.album.member
                            .ready(this.album.id, true)
                            .then(() => {
                                this.show = false;
                                this.$emit("deleted");
                            });
                    })
                    .catch((err) => {
                        console.log(err); // debug
                        this.$message.error("删除失败");
                    });
            },
            sendCode() {
                return api.v1.album.vcode(this.album.id);
            }
        }
    }
</script>

<style lang="less" scoped>
    .code-button {
        margin-right: -8px;
    }
</style>
